import AxiosApi from "./axios.service";
import { peticionPost } from "Componentes/ComponenteAxios";
const API_URL = "https://api.fichajedigital.com/api/";
export default (idusuario, tipo, pin, sede) => {
  return new Promise(async (resolve, reject) => {
    let data = {
      idUsuario: idusuario,
      tipo: tipo,
      codigoPin: pin,
      id_empresaSede: sede,
    };

    const { peticion, error } = await peticionPost("/panel/fichaje", data);
    if (error) {
      console.log(error);
      reject(error);
    }
    if (peticion) {
      resolve(peticion);
    }
    // AxiosApi.axiosApi
    // .post(API_URL+'panel/fichaje',data)
    // .then((response) => {

    //     console.log(response);
    //     if (response.data){
    //       resolve(response.data)
    //     }
    //     if(response.name && response.name=='AxiosError'){
    //         reject (response)
    //     }

    // })
    // .catch((error) => {

    //     console.log(error.response);
    //     reject(error)
    // });
  });
};
